import {
  MARK_ATTENDANCE_REQUEST,
  MARK_ATTENDANCE_SUCCESS,
  MARK_ATTENDANCE_FAILURE,
  RESET_ATTENDANCE_STATE,
  SET_LOCATION_ERROR,
  CLEAR_LOCATION_ERROR,
  FETCH_ATTENDANCE_HISTORY_REQUEST,
  FETCH_ATTENDANCE_HISTORY_SUCCESS,
  FETCH_ATTENDANCE_HISTORY_FAILURE
} from "../actions/actionTypes";

const initialState = {
  isSubmitting: false,
  success: false,
  error: null,
   history: [],
  locationError: null,
};

const attendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case MARK_ATTENDANCE_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        success: false,
        error: null,
      };
    case MARK_ATTENDANCE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        success: true,
        error: null,
      };
    case MARK_ATTENDANCE_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        success: false,
        error: action.payload,
      };
    case SET_LOCATION_ERROR:
      return {
        ...state,
        locationError: action.payload,
      };
    case CLEAR_LOCATION_ERROR:
      return {
        ...state,
        locationError: null,
      };
    case RESET_ATTENDANCE_STATE:
      return {
        ...initialState,
        locationError: null,
      };
      case FETCH_ATTENDANCE_HISTORY_REQUEST:
      return {
        ...state,
        isFetchingHistory: true,
        historyError: null,
      };
    case FETCH_ATTENDANCE_HISTORY_SUCCESS:
      return {
        ...state,
        isFetchingHistory: false,
        history: action.payload,
      };
    case FETCH_ATTENDANCE_HISTORY_FAILURE:
      return {
        ...state,
        isFetchingHistory: false,
        historyError: action.payload,
      };
    default:
      return state;
  }
};

export default attendanceReducer;